import script from "./Expand.vue?vue&type=script&lang=ts&setup=true"
export * from "./Expand.vue?vue&type=script&lang=ts&setup=true"

import "./Expand.vue?vue&type=style&index=0&id=5bb386fe&lang=scss"

const __exports__ = script;

export default __exports__